import React from "react";
import { Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import { SOUND_NAME } from "../../../../sounds";
import { ASSET_NAME } from "../../../../assets";
import { PixiSettings } from "../../../../pixiSettings";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { soundManager } from "../../../../SoundManager";

const PixiButtonNo = ({
  onClick,
  disabled = false,
  x = 0,
  y = 0,
  width,
  height,
}) => {
  const { device, orientation, symbolScale } = useDimensions();

  // Popup button dimensions - fixed size with responsive scaling
  const getResponsiveButtonSize = () => {
    let deviceMultiplier = 1.0; // Default full size

    if (device === PixiSettings.DEVICE.MOBILE) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        // Mobile portrait: bigger size
        deviceMultiplier = 1.0;
      } else {
        // Mobile landscape: standard size
        deviceMultiplier = 1.0;
      }
    } else if (device === PixiSettings.DEVICE.TABLET) {
      if (orientation === PixiSettings.ORIENTATION.PORTRAIT) {
        // Tablet portrait: bigger size
        deviceMultiplier = 1.0;
      } else {
        // Tablet landscape: standard size
        deviceMultiplier = 1.0;
      }
    } else {
      // Desktop: standard size
      deviceMultiplier = 1.0;
    }

    // Use symbol scaling factor from DimensionsContext

    // Max dimensions from PixiSettings, but can scale down infinitely
    const baseWidth = PixiSettings.POPUP_BUTTON_MAX_WIDTH;
    const baseHeight = PixiSettings.POPUP_BUTTON_MAX_HEIGHT;

    // Apply both device multiplier and symbol scaling
    const finalWidth = baseWidth * deviceMultiplier * symbolScale;
    const finalHeight = baseHeight * deviceMultiplier * symbolScale;

    return {
      width: Math.min(finalWidth, baseWidth), // Don't exceed max even with scaling
      height: Math.min(finalHeight, baseHeight),
    };
  };

  // Use passed size props if available, otherwise calculate responsive size
  const buttonSize =
    width && height ? { width, height } : getResponsiveButtonSize();

  const handleClick = () => {
    if (disabled) return;
    soundManager.play(SOUND_NAME.button_click);
    if (onClick) onClick();
  };

  // Use button PNG texture
  const buttonTexture = PIXI.Assets.get(ASSET_NAME.button_no);

  if (!buttonTexture) {
    return null; // Don't render if texture not loaded
  }

  return (
    <Sprite
      texture={buttonTexture}
      name="primary_button_no"
      anchor={0.5}
      x={x}
      y={y}
      width={buttonSize.width}
      height={buttonSize.height}
      eventMode={disabled ? "none" : "static"}
      cursor={disabled ? "default" : "pointer"}
      onpointertap={handleClick}
      alpha={disabled ? 0.5 : 1.0}
    />
  );
};

export default PixiButtonNo;
